var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteEx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0256 4.23828L14.5481 11.9622C14.4261 13.9355 14.3651 14.9222 13.8705 15.6317C13.6259 15.9824 13.3111 16.2784 12.9459 16.5008C12.2073 16.9508 11.2187 16.9508 9.24153 16.9508C7.26179 16.9508 6.27189 16.9508 5.53284 16.5C5.16745 16.2772 4.85249 15.9806 4.60801 15.6293C4.11353 14.9188 4.05387 13.9307 3.93457 11.9545L3.46875 4.23828",
    stroke: "black",
    strokeWidth: 1.15568,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3125 4.23761H16.1807M12.3713 4.23761L11.8454 3.1526C11.496 2.43186 11.3213 2.07149 11.0199 1.84674C10.9531 1.79688 10.8823 1.75254 10.8083 1.71414C10.4746 1.54102 10.0741 1.54102 9.27317 1.54102C8.4521 1.54102 8.0416 1.54102 7.70235 1.72139C7.62717 1.76137 7.55543 1.80752 7.48786 1.85934C7.18303 2.0932 7.01276 2.46675 6.6722 3.21387L6.20554 4.23761",
    stroke: "black",
    strokeWidth: 1.15568,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32031 12.7126V8.08984",
    stroke: "black",
    strokeWidth: 1.15568,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1719 12.7126V8.08984",
    stroke: "black",
    strokeWidth: 1.15568,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteEx);
export default __webpack_public_path__ + "static/media/delete-ex.7843deec24c06957499bd57a7e8ecc97.svg";
export { ForwardRef as ReactComponent };